module.exports = __webpack_public_path__ + "au.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/au.svg
// module id = 428
// module chunks = 0